import { useEffect, useState } from 'react';
import { ui } from '@procuros/datachecks';

import { applyRowMasksToData, getUiDetails } from 'services/datachecks/datachecks';
import { logError } from 'services/logging/logging';
import { ProcessSpecificationDTO, TaskBaseDTO } from 'support/types';

type FieldsParam = ProcessSpecificationDTO['fields'] | NonNullable<TaskBaseDTO['actions']>;

type DataChecksResult = {
  data: any;
  uiConfig: Array<ui.Section> | undefined;
  isLoading: boolean;
  promise?: Promise<{ data: any; uiConfig: Array<ui.Section> }>;
};

export const useFlattenDataAndUIConfig = (
  processSpecificationFields: FieldsParam | undefined,
  originalData: Record<string, unknown> | null | undefined,
): DataChecksResult => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataChecks, setDataChecks] = useState<{
    data?: unknown;
    uiConfig?: Array<ui.Section>;
  }>({});

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    if (!processSpecificationFields || !originalData) {
      return;
    }

    getUiDetails({ fields: processSpecificationFields as ProcessSpecificationDTO['fields'], data: originalData })
      .then((out) => {
        console.log({ originalData, out });
        if (!mounted) {
          return;
        }

        const flattenedData = applyRowMasksToData(out.values, out.view);
        setDataChecks({
          data: flattenedData,
          uiConfig: out.view?.map((section: any) => {
            if (section.type === 'line_items') {
              return {
                ...section,
                fields: section.fields.map((field: any) => {
                  if (field.id === 'transport_units') {
                    return {
                      ...field,
                      extraFields: {
                        disabledIfNested: true,
                      },
                    };
                  }
                  return field;
                }),
              };
            }
            return section;
          }),
        });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        logError(error);
      });

    return () => {
      mounted = false;
    };
  }, [originalData, processSpecificationFields]);

  return {
    uiConfig: dataChecks.uiConfig,
    data: dataChecks.data,
    isLoading,
  };
};
